import { Status } from '../model/payment.types'

export const statusCodes = {
  [Status.SUCCESS]: [2, 3, 4],
  [Status.WAIT]: [5, 7],
  [Status.FAIL]: [6, 8],
}
